import React from "react";
import {
  FirstPage,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  LastPage,
} from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useStyles from "./data-table-pagination-actions.style";

interface OcDataTablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number,
  ) => void;
}

export const OcDataTablePaginationActions: React.FC<
  OcDataTablePaginationActionsProps
> = ({ count, page, rowsPerPage, onPageChange }) => {
  const classes = useStyles();
  const theme = useTheme();

  const handleFirstPageButtonClick = (
    event?: React.MouseEvent<HTMLButtonElement>,
  ) => {
    onPageChange(event ?? null, 0);
  };

  const handleBackButtonClick = (
    event?: React.MouseEvent<HTMLButtonElement>,
  ) => {
    onPageChange(event ?? null, page - 1);
  };

  const handleNextButtonClick = (
    event?: React.MouseEvent<HTMLButtonElement>,
  ) => {
    onPageChange(event ?? null, page + 1);
  };

  const handleLastPageButtonClick = (
    event?: React.MouseEvent<HTMLButtonElement>,
  ) => {
    onPageChange(
      event ?? null,
      Math.max(0, Math.ceil(count / rowsPerPage) - 1),
    );
  };

  return (
    <div id="oc-data-table-pagination-actions-buttons" className={classes.root}>
      <IconButton
        id="oc-data-table-pagination-first-page-button"
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPage /> : <FirstPage />}
      </IconButton>
      <IconButton
        id="oc-data-table-pagination-previous-page-button"
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        id="oc-data-table-pagination-next-page-button"
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        id="oc-data-table-pagination-last-page-button"
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPage /> : <LastPage />}
      </IconButton>
    </div>
  );
};

export default OcDataTablePaginationActions;
